import { Button } from '~/shared/components/buttons/Button';
import { ChevronLeft } from 'lucide-react';
import { useGoalsAndInterventionsWizard } from '../GoalsAndInterventionsWizardContext';
import { FormRegistrySubmitButton } from '~/shared/forms/FormRegistryModal';

export function CaptureInterventionDetailsFooter() {
	const { dispatch } = useGoalsAndInterventionsWizard();

	return (
		<div className="flex items-center gap-2">
			<Button onClick={() => dispatch({ type: 'PREVIOUS_CLICKED' })} Icon={ChevronLeft} label="Previous" />
			<FormRegistrySubmitButton />
		</div>
	);
}
